import * as _m0 from "protobufjs/minimal";
import { Long } from "@osmonauts/helpers";
export let Validator_ValidatorStatus;
(function (Validator_ValidatorStatus) {
  Validator_ValidatorStatus[Validator_ValidatorStatus["ACTIVE"] = 0] = "ACTIVE";
  Validator_ValidatorStatus[Validator_ValidatorStatus["INACTIVE"] = 1] = "INACTIVE";
  Validator_ValidatorStatus[Validator_ValidatorStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Validator_ValidatorStatus || (Validator_ValidatorStatus = {}));
export let Validator_ValidatorStatusSDKType;
(function (Validator_ValidatorStatusSDKType) {
  Validator_ValidatorStatusSDKType[Validator_ValidatorStatusSDKType["ACTIVE"] = 0] = "ACTIVE";
  Validator_ValidatorStatusSDKType[Validator_ValidatorStatusSDKType["INACTIVE"] = 1] = "INACTIVE";
  Validator_ValidatorStatusSDKType[Validator_ValidatorStatusSDKType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Validator_ValidatorStatusSDKType || (Validator_ValidatorStatusSDKType = {}));
export function validator_ValidatorStatusFromJSON(object) {
  switch (object) {
    case 0:
    case "ACTIVE":
      return Validator_ValidatorStatus.ACTIVE;
    case 1:
    case "INACTIVE":
      return Validator_ValidatorStatus.INACTIVE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Validator_ValidatorStatus.UNRECOGNIZED;
  }
}
export function validator_ValidatorStatusToJSON(object) {
  switch (object) {
    case Validator_ValidatorStatus.ACTIVE:
      return "ACTIVE";
    case Validator_ValidatorStatus.INACTIVE:
      return "INACTIVE";
    default:
      return "UNKNOWN";
  }
}
function createBaseValidatorExchangeRate() {
  return {
    internalTokensToSharesRate: "",
    epochNumber: Long.UZERO
  };
}
export const ValidatorExchangeRate = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.internalTokensToSharesRate !== "") {
      writer.uint32(10).string(message.internalTokensToSharesRate);
    }
    if (!message.epochNumber.isZero()) {
      writer.uint32(16).uint64(message.epochNumber);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidatorExchangeRate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.internalTokensToSharesRate = reader.string();
          break;
        case 2:
          message.epochNumber = reader.uint64();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$internalToken;
    const message = createBaseValidatorExchangeRate();
    message.internalTokensToSharesRate = (_object$internalToken = object.internalTokensToSharesRate) !== null && _object$internalToken !== void 0 ? _object$internalToken : "";
    message.epochNumber = object.epochNumber !== undefined && object.epochNumber !== null ? Long.fromValue(object.epochNumber) : Long.UZERO;
    return message;
  }
};
function createBaseValidator() {
  return {
    name: "",
    address: "",
    status: 0,
    commissionRate: Long.UZERO,
    delegationAmt: "",
    weight: Long.UZERO,
    internalExchangeRate: undefined
  };
}
export const Validator = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.address !== "") {
      writer.uint32(18).string(message.address);
    }
    if (message.status !== 0) {
      writer.uint32(24).int32(message.status);
    }
    if (!message.commissionRate.isZero()) {
      writer.uint32(32).uint64(message.commissionRate);
    }
    if (message.delegationAmt !== "") {
      writer.uint32(42).string(message.delegationAmt);
    }
    if (!message.weight.isZero()) {
      writer.uint32(48).uint64(message.weight);
    }
    if (message.internalExchangeRate !== undefined) {
      ValidatorExchangeRate.encode(message.internalExchangeRate, writer.uint32(58).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidator();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.name = reader.string();
          break;
        case 2:
          message.address = reader.string();
          break;
        case 3:
          message.status = reader.int32();
          break;
        case 4:
          message.commissionRate = reader.uint64();
          break;
        case 5:
          message.delegationAmt = reader.string();
          break;
        case 6:
          message.weight = reader.uint64();
          break;
        case 7:
          message.internalExchangeRate = ValidatorExchangeRate.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$name, _object$address, _object$status, _object$delegationAmt;
    const message = createBaseValidator();
    message.name = (_object$name = object.name) !== null && _object$name !== void 0 ? _object$name : "";
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    message.status = (_object$status = object.status) !== null && _object$status !== void 0 ? _object$status : 0;
    message.commissionRate = object.commissionRate !== undefined && object.commissionRate !== null ? Long.fromValue(object.commissionRate) : Long.UZERO;
    message.delegationAmt = (_object$delegationAmt = object.delegationAmt) !== null && _object$delegationAmt !== void 0 ? _object$delegationAmt : "";
    message.weight = object.weight !== undefined && object.weight !== null ? Long.fromValue(object.weight) : Long.UZERO;
    message.internalExchangeRate = object.internalExchangeRate !== undefined && object.internalExchangeRate !== null ? ValidatorExchangeRate.fromPartial(object.internalExchangeRate) : undefined;
    return message;
  }
};